// ============================================================
//  src/components/common/StatusBadge.js
// ============================================================
import React from 'react';

const statusMap = {
  approved:   'badge-success', completed: 'badge-success', success: 'badge-success',
  active:     'badge-success', credit:    'badge-success', verified: 'badge-success',
  pending:    'badge-warning', processing: 'badge-warning', queued: 'badge-warning',
  rejected:   'badge-danger',  failed:     'badge-danger',  cancelled: 'badge-danger',
  debit:      'badge-danger',  blocked:    'badge-danger',
  inactive:   'badge-muted',   unknown:    'badge-muted',
};

export function StatusBadge({ status = '' }) {
  const key   = status.toLowerCase();
  const cls   = statusMap[key] || 'badge-muted';
  return <span className={`badge ${cls}`}>{status}</span>;
}

// ============================================================
//  src/components/common/EmptyState.js
// ============================================================
export function EmptyState({ icon = 'fa-inbox', title = 'Nothing here', description, action }) {
  return (
    <div className="empty-state">
      <i className={`fas ${icon}`} />
      <h4>{title}</h4>
      {description && <p>{description}</p>}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}

// ============================================================
//  src/components/common/PageLoader.js
// ============================================================
export function PageLoader({ text = 'Loading…' }) {
  return (
    <div className="page-loader">
      <span className="spinner spinner-dark" style={{ width: 28, height: 28, borderWidth: 3 }} />
      <span>{text}</span>
    </div>
  );
}

// ============================================================
//  src/components/common/Card.js
// ============================================================
import './Card.css';

export function Card({ title, action, children, noPad = false }) {
  return (
    <div className="page-card">
      {title && (
        <div className="page-card-hdr">
          <h3>{title}</h3>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={noPad ? '' : 'page-card-body'}>{children}</div>
    </div>
  );
}
